import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A new page starts at the top; a link with a hash (`/privacy#grievance-officer`) lands on that
 * section, waiting a few frames for lazily loaded pages to render it.
 */
export const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    let frames = 0;
    let raf = 0;
    const find = () => {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el) el.scrollIntoView({ block: 'start' });
      else if (frames++ < 30) raf = requestAnimationFrame(find);
    };
    find();
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);
  return null;
};
